import * as React from 'react';

const Default: React.FC = ({ children }) => {
    return <>{children}</>;
}

export default Default;